import React from 'react'
import styled from 'styled-components'
import { Box } from 'rebass/styled-components'
import { Link } from 'gatsby'

import BrandmarkAnimated from '../../assets/icons/brandmark-animated.svg'
import BrandmarkStatic from '../../assets/icons/brandmark-static.svg'

const BrandmarkImage = () => {
    // Check if window is defined (so if in the browser or in node.js).
    const isBrowser = typeof window !== 'undefined'
    const location = isBrowser ? window.location.pathname : '/'
    return (
        <Box
            sx={{
                pointerEvents: 'none',
            }}
        >
            <img src="/brandmarks/kidston-20-years.png" alt="Kidston 20 Years" style={{ maxWidth: '100px' }} />
        </Box>
    )
}

const BrandmarkAnchor = styled(Link)`
    background-color: ${(props) => props.theme.colors.white};
    display: block;
    left: calc(50% - 50px);
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 9px;
    padding-left: 6px;
    padding-right: 6px;
    padding-top: 10px;
    position: absolute;
    top: 0;
    width: 100px;
    z-index: 10;

    @media (max-width: ${(props) => props.theme.breakpoints.sm}) {
        left: auto;
        padding-bottom: 10px;
        padding-left: 7px;
        padding-right: 7px;
        position: relative;
        top: auto;
        width: 80px;
    }
`

const Brandmark = () => {
    return (
        <BrandmarkAnchor
            to='/'
            aria-label='Link to homepage'
        >
            <BrandmarkImage />
        </BrandmarkAnchor>
    )
}
export default Brandmark
